<div class="product-info">
  <div class="product-info-options">
    <app-toggle-input
      [groupBy2InLine]="true"
      placeholder="ProductInfo.RiskDuration"
      [form]="form"
      [optionsList]="waitingPeriodList"
      [control]="form.get('waitingPeriod')"
      appConfigSettingsParagraph
      required
      isRequiredMessageKey="Calculation.RequiredField"
      additionalInfoInsurer="ProductInfo.RiskDurationAdditionalInfo"
    ></app-toggle-input>
    <app-toggle-input
      [groupBy2InLine]="true"
      placeholder="ProductInfo.MentalIllness"
      [form]="form"
      [optionsList]="yesNoList"
      [control]="form.get('mentalIllness')"
      appConfigSettingsParagraph
      required
      isRequiredMessageKey="Calculation.RequiredField"
    ></app-toggle-input>
    <app-toggle-input
      [groupBy2InLine]="true"
      placeholder="ProductInfo.IndexationUsage"
      [form]="form"
      [optionsList]="yesNoList"
      [control]="form.get('indexationUsage')"
      appConfigSettingsParagraph
      required
      isRequiredMessageKey="Calculation.RequiredField"
      additionalInfoInsurer="ProductInfo.IndexationUsageAdditionalInfo"
    ></app-toggle-input>
  </div>
  <div class="product-info-premium-block">
    <ng-container *ngIf="isValidCalculation">
      <app-premium-block
        [isMobile]="true"
        [isDiscountTextShown]="true"
        [isStatementsAgreed]="false"
        (submitEvent)="submitApplication()"
        [showProductDetails]="true"
        [productType]="productType"
      ></app-premium-block>
    </ng-container>
    <app-notification-block
      [notification]="this.notificationEvent"
      appConfigSettingsParagraph
    ></app-notification-block>
  </div>
</div>
